import {
  AdminFormTemplatesView,
  // ImageFormBuilder,
  // ImageFormBuilderPreview,
  // ImageFormEditor,
  // ImageFormUploader,
  PageNotFound,
  AuthGate,
  i18nInit,
  useReloadOnNewVersion,
} from '@employ-engage/common-components';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
// import LandingPage from './landing-page/landing-page';
import Home from './home/home';
import AdminPage from './admin-page/admin-page';
import RedirectToUserMainDashboard from './redirect-to-user-main-dashboard/redirect-to-user-main-dashboard';
import Dashboard from './dashboard/dashboard';
import AdminFormsView from './admin-forms-view/admin-forms-view';
import FormResponseStatusPage from './form-response-status/form-response-status';
import AdminFormTemplatesViewWrapper from './admin-form-templates-view-wrapper/admin-form-templates-view-wrapper';
import ReportsContainerPage from './reports-container-page/reports-container-page';
import ReportsPageWrapper from './reports-page-wrapper/reports-page-wrapper';
import ReportBuilderPage from './report-builder-page/report-builder-page';
import Employees from './employees/employees';
import Settings from './settings/settings';
import AccountSettings from './account-settings/account-settings';
import SetupSettings from './setup-settings/setup-settings';
import DeleteAccountSettings from './delete-account-settings/delete-account-settings';
import NotificationSettings from './notification-settings/notification-settings';
import BillingSettings from './billing-settings/billing-settings';
import SmsConsentPage from './sms-consent-page/sms-consent-page';
import SharedResponsePage from './shared-response-page/shared-response-page';
import Kiosk from './kiosk/kiosk';
import SurveyGreeting from './survey-greeting/survey-greeting';
import Survey from './survey/survey';
import BeginSurvey from './begin-survey/begin-survey';
import SurveyPage from './survey-page/survey-page';
import SurveyComplete from './survey-complete/survey-complete';
import NonAccountUserRoutes from './non-account-user-routes/non-account-user-routes';
import AcceptInvitePage from './accept-invite-page/accept-invite-page';
import CompanyPicker from './company-picker/company-picker';
import UserHome from './user-home/user-home';
import UserAccountSettings from './user-account-settings/user-account-settings';
import DeleteCompanySettings from './delete-company-settings/delete-company-settings';
import TeamSettings from './team-settings/team-settings';
import InvitePage from './invite-page/invite-page';
import InviteAcceptancePage from './invite-page/invite-acceptance-page';
import InviteNotFound from './invite-page/invite-not-found';
import CompanyWrapper from './company-wrapper/company-wrapper';
import ResetPasswordPage from './reset-password-page/reset-password-page';
import DataFeedSettings from './data-feed-settings/data-feed-settings';
import SupportAccessLayer from './support-access/support-access-layer';
import SupportSessionStartPage from './support-access/support-session-start-page';

i18nInit();

export function App() {
  const clientRoutes = (
    <>
      <Route
        path="/"
        element={<NonAccountUserRoutes />}
        errorElement={<div>Error loading NonAccountUserRoutes</div>}
      >
        <Route
          index
          element={<Home />}
          errorElement={<div>Error loading Home</div>}
        />
        <Route
          path="user/home"
          element={
            <AuthGate>
              <SupportAccessLayer>
                <UserHome />
              </SupportAccessLayer>
            </AuthGate>
          }
          errorElement={<div>Error loading UserHome</div>}
        >
          <Route
            index
            element={<CompanyPicker />}
            errorElement={<div>Error loading CompanyPicker</div>}
          />
          <Route
            path="settings"
            element={<UserAccountSettings />}
            errorElement={<div>Error loading UserAccountSettings</div>}
          >
            <Route
              index
              element={<AccountSettings />}
              errorElement={<div>Error loading AccountSettings</div>}
            />
            <Route
              path="delete"
              element={<DeleteAccountSettings />}
              errorElement={<div>Error loading DeleteAccountSettings</div>}
            />
            <Route
              path="notifications"
              element={<NotificationSettings />}
              errorElement={<div>Error loading NotificationSettings</div>}
            />
            <Route
              path="billing"
              element={<BillingSettings />}
              errorElement={<div>Error loading BillingSettings</div>}
            />
          </Route>
        </Route>
      </Route>
      <Route
        path="support-session/:requestId"
        element={<SupportSessionStartPage />}
        errorElement={<div>Error loading SupportSessionStartPage</div>}
      />
      {/* Outside :companyId on purpose: whoever follows an invitation link is
          not a member of that company yet, so there is no company in the path
          for them to be routed under. */}
      <Route
        path="accept-invite"
        element={<AcceptInvitePage />}
        errorElement={<div>Error loading AcceptInvitePage</div>}
      />
      {/* A manager's private link to one response, texted as
          https://employengage.app/r/<token> (filed in the toll-free
          verification, so the path must not change). Outside :companyId:
          the token alone is the key. */}
      <Route
        path="r/:token"
        element={<SharedResponsePage />}
        errorElement={<div>Error loading SharedResponsePage</div>}
      />
      <Route
        path=":companyId"
        element={<CompanyWrapper />}
        errorElement={<div>Error loading CompanyWrapper</div>}
      >
        <Route
          path="admin"
          element={
            <AuthGate>
              <SupportAccessLayer>
                <AdminPage />
              </SupportAccessLayer>
            </AuthGate>
          }
          errorElement={<div>Error loading AdminPage</div>}
        >
          <Route
            index
            element={<RedirectToUserMainDashboard />}
            errorElement={<div>Error loading RedirectToUserMainDashboard</div>}
          />
          <Route
            path="dashboard"
            element={<Dashboard />}
            errorElement={<div>Error loading Dashboard</div>}
          />
          <Route
            path="forms"
            element={<AdminFormsView />}
            errorElement={<div>Error loading AdminFormsView</div>}
          />
          {/* A sibling rather than a child of `forms`: the forms view is a
              table, not a layout, and has no Outlet to render a child into. */}
          <Route
            path="forms/:formId/responses"
            element={<FormResponseStatusPage />}
            errorElement={<div>Error loading FormResponseStatusPage</div>}
          />
          <Route
            path="templates"
            element={<AdminFormTemplatesViewWrapper />}
            errorElement={
              <div>Error loading AdminFormTemplatesViewWrapper</div>
            }
          >
            <Route
              index
              element={
                <AdminFormTemplatesView
                  shouldShowTemplateMarketplace
                  isPublishingEnabled
                />
              }
              errorElement={<div>Error loading AdminFormTemplatesView</div>}
            />
          </Route>
          <Route
            path="reports"
            element={<ReportsContainerPage />}
            errorElement={<div>Error loading ReportsContainerPage</div>}
          >
            <Route
              index
              element={<ReportsPageWrapper />}
              errorElement={<div>Error loading ReportsPageWrapper</div>}
            />
            <Route
              path="report-builder"
              element={<ReportBuilderPage />}
              errorElement={<div>Error loading ReportBuilderPage</div>}
            />
          </Route>
          <Route
            path="employees"
            element={<Employees />}
            errorElement={<div>Error loading Employees</div>}
          />
          <Route
            path="settings"
            element={<Settings />}
            errorElement={<div>Error loading Settings</div>}
          >
            <Route
              index
              element={<SetupSettings />}
              errorElement={<div>Error loading SetupSettings</div>}
            />
            <Route
              path="team"
              element={<TeamSettings />}
              errorElement={<div>Error loading TeamSettings</div>}
            />
            <Route
              path="data-feed"
              element={<DataFeedSettings />}
              errorElement={<div>Error loading DataFeedSettings</div>}
            />
            <Route
              path="delete-company"
              element={<DeleteCompanySettings />}
              errorElement={<div>Error loading DeleteCompanySettings</div>}
            />
          </Route>
        </Route>
        <Route
          path="sms-consent/employee/:employeeId"
          element={<SmsConsentPage />}
          errorElement={<div>Error loading SmsConsentPage</div>}
        />
        <Route
          path="invite/:inviteId"
          element={<InvitePage />}
          errorElement={<div>Error loading InvitePage</div>}
        />
        <Route
          path="invite-acceptance/:inviteId"
          element={<InviteAcceptancePage />}
          errorElement={<div>Error loading InviteAcceptancePage</div>}
        />
        <Route
          path="invite-not-found"
          element={<InviteNotFound />}
          errorElement={<div>Error loading InviteNotFound</div>}
        />
        <Route
          path="form"
          element={<Kiosk />}
          errorElement={<div>Error loading Kiosk</div>}
        >
          <Route
            index
            element={<SurveyGreeting />}
            errorElement={<div>Error loading SurveyGreeting</div>}
          />
          <Route
            path=":formId/employee/:employeeId"
            element={<Survey />}
            errorElement={<div>Error loading Survey</div>}
          >
            <Route
              index
              element={<BeginSurvey />}
              errorElement={<div>Error loading BeginSurvey</div>}
            />
            <Route
              path="response/:responseId/page/:pageNumber"
              element={<SurveyPage />}
              errorElement={<div>Error loading SurveyPage</div>}
            />
          </Route>
          <Route
            path=":surveyId/employee/:employeeId/complete"
            element={<SurveyComplete />}
            errorElement={<div>Error loading SurveyComplete</div>}
          />
          <Route
            path="*"
            element={<PageNotFound />}
            errorElement={<div>Error loading PageNotFound</div>}
          />
        </Route>
        <Route
          path="*"
          element={<PageNotFound />}
          errorElement={<div>Error loading PageNotFound</div>}
        />
      </Route>
      <Route
        path="auth/reset-password"
        element={<ResetPasswordPage />}
        errorElement={<div>Error loading ResetPasswordPage</div>}
      />
      <Route
        path="*"
        element={<PageNotFound />}
        errorElement={<div>Error loading PageNotFound</div>}
      />
    </>
  );

  const router = createBrowserRouter(createRoutesFromElements(clientRoutes));

  useReloadOnNewVersion(router, __BUILD_ID__);

  return <RouterProvider router={router} />;
}

export default App;
